import React, { FC } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

import ErrorBoundary from '@buyside/components/presentation/ErrorBoundary/errorBoundary';
import FundProfileIndexPage from '@buyside/components/presentation/FundProfileIndexPage/fundProfileIndexPage';

import { employerProfilesUrl } from '@buyside/util/urlHelper';

const FundProfileIndexPageRoot: FC = () => {
  return (
    <ErrorBoundary pageName="fund profiles index">
      <Router basename={employerProfilesUrl()}>
        <FundProfileIndexPage />
      </Router>
    </ErrorBoundary>
  );
};

export default FundProfileIndexPageRoot;
